import { linkWhatsApp } from '../utils';
import type { PessoaFiltrada } from '../types';

interface Props {
  pessoas: PessoaFiltrada[];
  fotoUrlMap: Map<number, string>;
  total: number;
  carregando: boolean;
  baixando: boolean;
  temFiltros: boolean;
  aoBaixar: () => void;
  aoLimpar: () => void;
}

function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  const primeira = partes[0]?.[0] ?? '';
  const segunda = partes.length > 1 ? partes[1][0] : '';
  return (primeira + segunda).toUpperCase();
}

export default function ListaFiltrada({
  pessoas,
  fotoUrlMap,
  total,
  carregando,
  baixando,
  temFiltros,
  aoBaixar,
  aoLimpar,
}: Props) {
  return (
    <div className="rounded-lg border border-secondary-200 bg-white">
      <div className="flex flex-col gap-3 border-b border-secondary-100 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <span className="text-[15px] font-medium text-foreground-950">
            {pessoas.length} de {total} inscritos
          </span>
          <p className="mt-0.5 text-xs text-secondary-400">
            Dentro da mesma pergunta, qualquer uma serve. Entre perguntas, todas precisam bater.
          </p>
        </div>
        <button
          type="button"
          onClick={aoBaixar}
          disabled={pessoas.length === 0 || baixando}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <i className="ri-download-2-line text-base" />
          {baixando ? 'Gerando…' : 'Baixar esta lista'}
        </button>
      </div>

      {carregando ? (
        <div className="p-8 text-center text-sm text-secondary-500">Carregando…</div>
      ) : pessoas.length === 0 ? (
        <div className="p-10 text-center">
          <p className="text-[15px] text-foreground-800">Ninguém bate com esses filtros.</p>
          {temFiltros && (
            <button
              type="button"
              onClick={aoLimpar}
              className="mt-4 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              Limpar filtros
            </button>
          )}
        </div>
      ) : (
        <div className="divide-y divide-secondary-100 px-4">
          {pessoas.map((p) => (
            <div key={p.inscricao_id} className="flex items-center gap-3 py-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-secondary-200 text-sm font-medium text-secondary-600">
                {fotoUrlMap.has(p.inscricao_id) ? (
                  <img
                    src={fotoUrlMap.get(p.inscricao_id)}
                    alt={`Foto de ${p.participante}`}
                    className="h-full w-full object-contain object-center"
                  />
                ) : (
                  iniciais(p.participante)
                )}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="truncate font-medium text-foreground-950">{p.participante}</span>
                  {p.equipe && (
                    <span className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
                      {p.equipe}
                    </span>
                  )}
                </div>
                <div className="mt-0.5 flex flex-wrap items-center gap-x-1.5 text-sm text-secondary-500">
                  <span>{p.participacao}</span>
                  {p.grupo && (
                    <>
                      <span className="text-secondary-300">·</span>
                      <span>{p.grupo}</span>
                    </>
                  )}
                  {p.cidade && (
                    <>
                      <span className="text-secondary-300">·</span>
                      <span>{p.cidade}</span>
                    </>
                  )}
                </div>
              </div>

              {p.telefone && (
                <a
                  href={linkWhatsApp(p.telefone)}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Abrir no WhatsApp"
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700 transition-colors hover:bg-accent-200"
                >
                  <i className="ri-whatsapp-line text-lg" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}